import { render, staticRenderFns } from "./ReceiveList.vue?vue&type=template&id=9e3e80da&scoped=true"
import script from "./ReceiveList.vue?vue&type=script&lang=js"
export * from "./ReceiveList.vue?vue&type=script&lang=js"
import style0 from "./ReceiveList.vue?vue&type=style&index=0&id=9e3e80da&prod&lang=scss&scoped=true"
import style1 from "./ReceiveList.vue?vue&type=style&index=1&id=9e3e80da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3e80da",
  null
  
)

export default component.exports